module.exports = __webpack_public_path__ + "img/facebook-light.8097eba1.svg";